import { createFileRoute } from "@tanstack/react-router";
import { cityHead } from "../lib/route-head";
import { CityPage } from "../components/city-page";


export const Route = createFileRoute("/pressure-washing-halfmoon-ny")({
  loader: async () => (await import("../data/cities")).getCity("pressure-washing-halfmoon-ny")!,
  head: ({ loaderData }) => cityHead("pressure-washing-halfmoon-ny", loaderData),
  component: RouteComponent,
});

function RouteComponent() {
  const content = Route.useLoaderData();
  return <CityPage content={content} />;
}
